import { AppModule } from 'app/module';
import { Input } from 'module/input/main';
import { serializeJson } from 'util/form';
import { Autocomplete } from 'module/autocomplete/main';
import { JobsFilter } from 'module/jobsFilter/main';
import { getJson, postJson } from 'util/xhr';
import 'module/button/main';
import './styles.scss';
import { user } from 'app/user';
import { GdprModal } from 'module/gdprModal/main';
import {
    ENDPOINT_JOBALARM,
    ENDPOINT_USER_LOGIN,
    API_ENDPOINT_PROXIMITY_LOCATION,
    API_ENDPOINT_AUTOCOMPLETE_KEYWORDS,
    API_ENDPOINT_AUTOCOMPLETE_LOCATIONS,
    API_ENDPOINT_FILTERS,
    API_ENDPOINT_JOBALARM_CREATE,
} from 'app/endpoints';
import { generic } from 'util/validationMessages';
import { fieldIsEmpty } from 'util/validate';
import { ValidationBoxBase } from 'module/validationBox/main';
import { Dropdown } from 'module/dropdown/main';
import { trackGa4 } from 'util/googleAnalytics';
import { JobAlarmNoSpamText } from 'module/jobAlarmNoSpamText/main';
import { MasterLayout } from 'layout/master/main';
import Template from './template.hbs';

const missingSearchCriteriaErrorMessage = 'Gib bitte mindestens einen Suchbegriff ein oder wähle einen Filter aus.';

export class JobAlarmEmptyStateForm extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            form: '.m-jobAlarmEmptyStateForm__form',
            errorBox: '.m-validationBoxBase',
            email: '.m-jobAlarmEmptyStateForm__inputGroup .m-input',
            keywords: '.m-jobAlarmEmptyStateForm__keywords .m-input',
            keywordsAutocomplete: '.m-jobAlarmEmptyStateForm__keywordsAutocomplete .m-autocomplete',
            keywordsContainer: '.m-jobAlarmEmptyStateForm__keywords',
            locations: '.m-jobAlarmEmptyStateForm__locations .m-input',
            locationsAutocomplete: '.m-jobAlarmEmptyStateForm__locationsAutocomplete .m-autocomplete',
            gdprModal: '.m-jobAlarmEmptyStateForm__gdprModal .m-gdprModal',
            hiddenFormInputs: ['.m-jobAlarmEmptyStateForm__formElement--mobileHidden'],
            mailInputHeadline: '.m-jobAlarmEmptyStateForm__mailInputHeadline',
            submitButton: '.m-jobAlarmEmptyStateForm__submit',
            jobsFilter: '.m-jobsFilter',
            filterContainer: '.m-jobAlarmEmptyStateForm__filter',
            mail: '.m-jobAlarmEmptyStateForm__mail',
            proximityDropdown: '.m-jobAlarmEmptyStateForm__proximity .m-dropdown',
            proximityContainer: '.m-jobAlarmEmptyStateForm__proximityContainer',
            submitContainer: '.m-jobAlarmEmptyStateForm__submitGroup',
            noSpamText: '.m-jobAlarmNoSpamText',
        };
    }

    getSerializedProps() {
        if (this.jobsFilter) {
            const filterProps = this.jobsFilter.getSerializedItems();
            if (Object.keys(filterProps).length > 0) {
                return { ...filterProps, ...this.props };
            }
        }
        return this.props;
    }

    getPropsFromDom() {
        return {
            isLoggedIn: !this.dom.mailInputHeadline,
            email: this.dom.form ? this.dom.form.email.value : '',
            exists: this.dom.button ? this.dom.button.getAttribute('data-jobalarm-id') : false,
            keywords: this.dom.form ? this.dom.form.keywords.value : '',
            locations: this.dom.form ? this.dom.form.locations.value : '',
            jobAlarmId: this.dom.button ? this.dom.button.getAttribute('data-jobalarm-id') : false,
            similarJobsAlarm: this.dom.inner ? this.dom.inner.getAttribute('data-is-similar') : false,
            mailInputHeadline: this.dom.mailInputHeadline ? this.dom.mailInputHeadline.innerText : false,
            submitButtonText: this.dom.submitButton ? this.dom.submitButton.innerText : '',
        };
    }

    subsProps() {
        if (this.email && this.props.errors) {
            if (this.props.errors.email) {
                this.email.setInvalid(this.props.errors.email);
            } else {
                this.email.setValid();
            }
        }
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);

        if (this.dom.gdprModal) {
            this.gdprModal = new GdprModal(this.dom.gdprModal);
        }
        if (this.dom.keywords && this.dom.keywordsAutocomplete) {
            this.keywords = new Input(this.dom.keywords);
            this.keywordsAutocomplete = new Autocomplete(this.dom.keywordsAutocomplete);
            this.keywordsAutocomplete.set({
                input: this.keywords,
                endpoint: API_ENDPOINT_AUTOCOMPLETE_KEYWORDS,
            });
        }
        if (this.dom.errorBox) {
            this.errorBox = new ValidationBoxBase(this.dom.errorBox);
        }
        if (this.dom.locations) {
            this.locations = new Input(this.dom.locations);
            this.locationsAutocomplete = new Autocomplete(this.dom.locationsAutocomplete);
            this.locationsAutocomplete.set({
                input: this.locations,
                endpoint: API_ENDPOINT_AUTOCOMPLETE_LOCATIONS,
            });
        }
        if (this.dom.proximityDropdown) {
            this.proximityDropdown = new Dropdown(this.dom.proximityDropdown);
            this.setProps({ proximity: this.proximityDropdown.getPropsFromDom(), ...this.props });
            this.proximityDropdown.events.on('closeAllDropdowns', () => this.closeAllDropdowns());
        }
        if (this.dom.jobsFilter) {
            this.jobsFilter = new JobsFilter(this.dom.jobsFilter);
        }

        if (this.dom.email) {
            this.email = new Input(this.dom.email);
        }

        if (this.dom.errorBox) {
            this.errorBox = new ValidationBoxBase(this.dom.errorBox);
        }
        if (this.dom.noSpamText) {
            this.noSpamText = new JobAlarmNoSpamText(this.dom.noSpamText);
        }
    }

    domEvents() {
        this.dom.form.addEventListener('submit', (e) => this.submitForm(e));
    }

    submitForm(e) {
        if (e) e.preventDefault();
        if (this.hasActiveAutocomplete()) {
            return;
        }

        if (this.validate()) {
            this.setProps({ proximity: this.proximityDropdown.getPropsFromDom(),
                jobsFilter: this.jobsFilter.props,
                ...this.getPropsFromDom() });

            this.createAlarm(serializeJson(this.dom.form));
        }
    }

    createAlarm(formData) {
        if (this.request) {
            this.request.abort();
        }

        if (this.dom.submitButton) {
            this.dom.submitButton.disabled = true;
        }

        const data = this.reduceArraysToStrings(formData);
        this.request = postJson(
            API_ENDPOINT_JOBALARM_CREATE,
            { data },
            (response) => this.onResponse(response),
            (error) => this.onResponseError(error),
        );
    }

    onResponse(response, calledFromController = false) {
        if (response.gdpr) {
            this.gdprModal.setProps(response.gdpr);
            this.gdprModal.updateProps({ visible: true, scrollTop: 0, active: true }, true);
            this.gdprModal.checkIfScrollEnd();
            this.events.emit('addModalStyle');
        } else {
            this.updateProps(response, true);
            if (!calledFromController) {
                trackGa4({
                    event: 'jobalarm_create_success',
                    method: 'Job Alarm Landingpage',
                    user_data: {
                        email: this.email.getValue(),
                    },
                });

                if (user.isLoggedIn()) {
                    window.location.replace(`${window.location.origin}${response.jobAlarmUrl}/${response.jobAlarmId}`);
                }
            }

            if (response.success) {
                this.events.emit('createJobAlarmSuccess', response);
            }
        }
    }

    onResponseError(response) {
        if (this.dom.submitButton) {
            this.dom.submitButton.disabled = false;
        }

        const errorsMeta = this.validation.handleBackendValidationErrors(response);
        this.events.emit('createJobAlarmFailure', { error: errorsMeta });

        if (this.email) {
            this.email.updateProps({ value: this.props.emailInputValue }, true);
        }

        return true;
    }

    closeAllDropdowns() {
        if (this.proximityDropdown) this.proximityDropdown.closeDropdown();
    }

    reduceArraysToStrings(data) {
        const newData = {};
        Object.keys(data).forEach((key) => {
            if (Array.isArray(data[key])) {
                if (data[key].length > 0) {
                    newData[key.slice(0, key.length - 2)] = data[key].reduce((state, acc) => `${state},${acc}`);
                }
            } else {
                newData[key] = data[key];
            }
        });
        return newData;
    }

    // When a logged-out user wants to select a salary, the previously selected filters
    // should be sent to the redirectUrl
    getUserJobSearchRequest() {
        let newProps = {};
        if (!this.jobsFilter.hasFilterMarkup()) {
            newProps = Object.assign(
                this.getSerializedProps(),
                // always send empty slugs from search form
                {
                    keywordSlug: false,
                    locationSlug: false,
                },
            );
        } else {
            newProps = Object.assign(
                serializeJson(this.dom.el),
                // always send empty slugs from search form
                {
                    keywordSlug: false,
                    locationSlug: false,
                },
            );
        }
        return newProps;
    }

    hasActiveAutocomplete() {
        const keywordsAutocompleteProps = this.keywordsAutocomplete.getProps();
        const locationsAutocompleteProps = this.locationsAutocomplete ? this.locationsAutocomplete.getProps() : false;

        return !!((keywordsAutocompleteProps && keywordsAutocompleteProps.selectedIndex)
            || (locationsAutocompleteProps && locationsAutocompleteProps.selectedIndex));
    }

    subEvents() {
        if (this.locationsAutocomplete) {
            this.locationsAutocomplete.events.on('changed', (e) => this.checkProximityStatus(e));
            this.locationsAutocomplete.events.on('hide', () => this.resetProximityDropdown());
        }
        if (this.jobsFilter) {
            this.propagateEvents(this.jobsFilter, 'openLoginModal');
            this.jobsFilter.events.on('closeProximityDropdown', () => this.closeProximityDropdown());
            this.jobsFilter.events.on('loadFilterMarkup', () => this.loadFilterMarkup());

            this.jobsFilter.events.on('openLoginModal', () => {
                this.layout.openLoginModal(`${ENDPOINT_USER_LOGIN}?redirectUrl=${ENDPOINT_JOBALARM}`, true, true);
            });
        }

        this.locations?.events.on('actionIconClicked', (e) => this.resetSearchInput(e, this.locations));

        this.keywords?.events.on('actionIconClicked', (e) => this.resetSearchInput(e, this.keywords));
        this.email?.events.on('actionIconClicked', () => this.email.resetValue());

        this.gdprModal?.events.on('acceptGdpr', () => this.acceptGdpr());
        this.gdprModal?.events.on('removeModalStyle', () => this.closeGdprModal());
    }

    closeProximityDropdown() {
        if (this.proximityDropdown) this.proximityDropdown.updateProps({ open: false }, true);
    }

    loadFilterMarkup() {
        if (this.loadFilterMarkupRequest) return;

        const url = `${API_ENDPOINT_FILTERS}?hideAggregations=1`;
        this.loadFilterMarkupRequest = getJson(
            url,
            {},
            (response) => this.jobsFilter.onFilterMarkupResponse(response),
        );
    }

    validationRules() {
        this.validation.useMessages(generic);

        this.validation.addRule(this.email, {
            rules: [{
                name: 'email',
            }],
        });

        this.validation.addRule(this, {
            name: 'jobalarm_empty',
            test: () => this.hasRequiredValues(),
            message: missingSearchCriteriaErrorMessage,
            sideEffects: ({ valid }) => {
                if (valid) {
                    this.keywords.setValid();
                    this.locations.setValid();
                } else {
                    this.keywords.setInvalid();
                    this.locations.setInvalid();
                }
            },
            validationMessageOutlet: this.errorBox,
        });
    }

    hasRequiredValues() {
        let valid = true;
        const filterSet = this.jobsFilter.hasActiveFilter();
        const emptyKeywordInput = fieldIsEmpty(this.keywords.dom.input.value);
        const emptyLocationInput = fieldIsEmpty(this.locations.dom.input.value);
        const emptySearchForm = !filterSet && emptyKeywordInput && emptyLocationInput;
        const emptyEmailInput = fieldIsEmpty(user.isLoggedIn()
            ? this.dom.el.querySelector('input[name=email]').value : this.email.dom.input.value);

        // Valid: Any keyword OR location OR filter
        if (emptySearchForm || emptyEmailInput) {
            valid = false;
        }
        return valid;
    }

    acceptGdpr() {
        if (this.gdprModal.validate()) {
            const gdprOptionalCheckBoxSize = Object.keys(this.gdprModal.props.optionalBox.items).length;
            const gdprRequiredCheckBoxSize = Object.keys(this.gdprModal.props.requiredBox.items).length;
            const data = serializeJson(this.dom.form);

            for (let i = 0; i < gdprOptionalCheckBoxSize; i += 1) {
                // eslint-disable-next-line max-len
                data[this.gdprModal.props.optionalBox.items[i].name] = this.gdprModal.props.optionalBox.items[i].checked;
            }

            for (let i = 0; i < gdprRequiredCheckBoxSize; i += 1) {
                // eslint-disable-next-line max-len
                data[this.gdprModal.props.requiredBox.items[i].name] = this.gdprModal.props.requiredBox.items[i].checked;
            }

            this.gdprModal.closeModal();
            this.createAlarm(data);
        }
    }

    closeGdprModal() {
        this.events.emit('removeModalStyle');
        if (this.dom.submitButton) {
            this.dom.submitButton.disabled = false;
        }
    }

    resetSearchInput(e, inputField) {
        const inputId = e.arguments[0];

        if (inputField) inputField.resetValue();
        if (inputId === 'locations' && this.proximityDropdown && !this.proximityDropdown.props.disabled) {
            this.proximityDropdown.resetOptions(true);
        }
    }

    resetProximityDropdown() {
        if (this.proximityDropdown && !this.proximityDropdown.props.disabled) {
            this.proximityDropdown.resetOptions(true);
        }
    }

    checkProximityStatus(e) {
        const query = e.arguments.length > 0 ? e.arguments[0] : null;

        if (query === null) {
            return;
        }

        if (this.proximityRequest) {
            this.proximityRequest.abort();
        }

        this.updateProps({ locations: query[0] });

        const encodedQuery = encodeURIComponent(query);
        const url = `${API_ENDPOINT_PROXIMITY_LOCATION}?query=${encodedQuery}`;

        this.proximityRequest = getJson(
            url,
            {},
            (response) => this.onProximityResponse(response),
            (error) => this.onProximityError(error),
        );
    }

    onProximityResponse(response) {
        const { isProximityDisabled } = response;

        if (isProximityDisabled) {
            this.proximityDropdown.resetOptions(isProximityDisabled);
        } else {
            this.proximityDropdown.enableDropdown();
        }
    }

    onProximityError() {
        this.proximityDropdown.resetOptions(true);
    }
}
